export enum PurchaseOrderStatus {
    Draft = 0,
    WaitingForSalesManApproval = 1,
    Placed=5,
    PartiallyPosted=6,
    Posted = 2,
    Synced = 3,
    RejectedBySalesAgent = 4
}